/**
 * abilityVfx — OCP mesh builders keyed by AbilitySpec.vfxId (AB-03).
 * Default painters use VFX specs; MeshFactory painters register via boot.
 */
import { getAbilityVfxSpec } from './abilityVfxSpecs.js';
import { buildDefaultAbilityMesh } from './abilityVfxMeshes.js';

const painters = new Map();

export function registerAbilityVfxPainter(vfxId, buildFn) {
  painters.set(vfxId, buildFn);
}

/** @returns {object|null} */
export function createAbilityVfxMesh(vfxId, THREE) {
  if (!vfxId || !THREE) return null;
  const spec = getAbilityVfxSpec(vfxId);
  if (!spec) return null;
  const custom = painters.get(vfxId);
  if (custom) return custom(THREE, spec);
  return buildDefaultAbilityMesh(THREE, spec);
}

export function _resetAbilityVfxPaintersForTests() {
  painters.clear();
}
